import { TWebsiteBuilderRichTextContent, websiteBuilderNormalizeRichTextContent } from "../../richText/websiteBuilderRichTextContent";
import {
  IWebsiteBuilderElementBase,
  IWebsiteBuilderElementDataBase,
  TWebsiteBuilderElement,
} from "./websiteBuilderElement";
import { websiteBuilderGenerateDefaultHideableNodeVisibility } from "../websiteBuilderHideableNode";

interface IWebsiteBuilderParagraphSettings {
  content: TWebsiteBuilderRichTextContent;
}

interface IWebsiteBuilderParagraphData extends IWebsiteBuilderElementDataBase {
  type: "paragraph";
  settings: IWebsiteBuilderParagraphSettings;
}

export interface IWebsiteBuilderParagraph extends IWebsiteBuilderElementBase {
  element: IWebsiteBuilderParagraphData;
}

export function isWebsiteBuilderParagraph(node: TWebsiteBuilderElement): node is IWebsiteBuilderParagraph {
  return node?.element?.type === "paragraph";
}

function generateDefaultParagraphSettings(): IWebsiteBuilderParagraphSettings {
  return {
    content: {
      type: "doc",
      attrs: {
        responsiveFontSize: {
          desktop: null,
          tablet: null,
          mobile: null,
        },
      },
      content: [{
        type: "paragraph",
        content: [{ type: "text", text: "Paragraph" }], // TODO: Translation
      }],
    },
  };
}

export function websiteBuilderGenerateDefaultParagraph(): IWebsiteBuilderParagraph {
  return {
    id: crypto.randomUUID(),
    type: "element",
    element: {
      type: "paragraph",
      layout: {
        desktop: {
          position: { x: 0, y: 0 },
          dimensions: { width: 150, height: 35 },
        },
        tablet: {
          position: { x: 0, y: 0 },
          dimensions: { width: 150, height: 35 },
        },
        mobile: {
          position: { x: 0, y: 0 },
          dimensions: { width: 150, height: 35 },
        },
      },
      visibility: websiteBuilderGenerateDefaultHideableNodeVisibility(),
      zIndex: 0,
      settings: generateDefaultParagraphSettings(),
    },
  };
}

export function websiteBuilderNormalizeParagraphSettings(partialSettings: Partial<IWebsiteBuilderParagraphSettings>): IWebsiteBuilderParagraphSettings {
  const defaultSettings = generateDefaultParagraphSettings();

  if (partialSettings == null) {
    return defaultSettings;
  }

  const normalizedSettings: IWebsiteBuilderParagraphSettings = {
    content: websiteBuilderNormalizeRichTextContent(partialSettings.content),
  };

  return normalizedSettings;
}
